import { graphql } from 'gatsby';
import React, { useEffect } from 'react';

import {
  ProductList,
  sendGtmProductClickEvent,
  sendGtmProductImpressionsEvent,
} from '@/utils/sendGtmEvents';

import { VariantGrid, VariantGridItem } from '../VariantGrid';
import { root } from './RichTextProductGrid.module.scss';

const RichTextProductGrid: React.FC<{
  node: { data: { target: Queries.RichTextProductGridFragment } };
}> = ({ node }) => {
  const entry = node.data.target;

  useEffect(() => {
    const hits = entry?.variants;

    if (hits.length > 0) {
      sendGtmProductImpressionsEvent({
        list: ProductList.EditorialPage,
        impressions: hits
          .map((hit, index) => {
            if (hit?.shopify?.price === undefined) {
              return null;
            }

            return {
              sku: hit.sku,
              productName: hit.productName,
              variantName: hit.variantName,
              price: hit.shopify.price.toString(),
              originalPrice: (
                hit.shopify.compareAtPrice || hit.shopify.price
              )?.toString(),
              position: index,
              slug: hit.slug,
            };
          })
          .filter(Boolean),
      });
    }
  }, [entry.variants]);

  if (!entry) {
    console.warn('[RichTextProductGrid] Entry not rendered', { node });
    return null;
  }

  let slug = null;
  switch (entry.link?.__typename) {
    case 'ContentfulPageProduct':
      slug = entry.link.defaultVariant?.slug;
      break;
    case 'ContentfulLink':
      slug = entry.link.slug || entry.link.entry.slug;
      break;
    case 'ContentfulPageCategory':
    case 'ContentfulPageDepartment':
    case 'ContentfulPageSubcategory':
    case 'ContentfulProductVariant':
      slug = entry.link.slug;
      break;
  }

  return (
    <div className={root}>
      <VariantGrid
        title={entry.title}
        titleTag="h3"
        linkLabel={slug ? entry.linkLabel : null}
        linkSlug={slug}
      >
        {entry.variants
          .filter((variant) => !!variant.shopify && !!variant.airtable)
          .map((variant, index) => (
            <VariantGridItem
              key={variant.sku}
              {...variant}
              onClick={() => {
                sendGtmProductClickEvent({
                  sku: variant.sku,
                  productName: variant.productName,
                  variantName: variant.variantName,
                  price: variant.shopify.price + '',
                  originalPrice:
                    (variant.shopify.compareAtPrice || variant.shopify.price) +
                    '',
                  slug: variant.slug,
                  list: ProductList.EditorialPage,
                  position: index,
                });
              }}
            />
          ))}
      </VariantGrid>
    </div>
  );
};

export default RichTextProductGrid;

export const query = graphql`
  fragment RichTextProductGrid on ContentfulComponentProductGrid {
    __typename
    contentful_id
    ...ProductGrid
  }
`;
